// src/components/Logbook.js
import React from 'react';

const Logbook = () => {
  return (
    <div className="w-full h-full container mx-auto p-4 md:p-8 text-white">
      <h1 className="text-4xl md:text-5xl font-bold">Página de Entrenamiento</h1>
      <p className="mt-4">Aquí se mostrarán las rutinas de entrenamiento.</p>
    </div>
  );
};
export default Logbook;